<template>
  <Adminlte>
      <div class="box box-primary center-block">
        <div class="box-header with-border">
          <i class="fa fa-table font-dark"></i>
          <h3 class="box-title">Exportação de dados - Questionários</h3>
        </div>

        <section class="content">
          <div class="row main-row">
            <div class="col-xs-12 col-md-6">
              <div class="inner-box">
                <ParksFilter :parks="parks" :disabled="waitingDownload" />
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <div class="inner-box">
                <h4>Ano do Questionário</h4>
                <div class="form-group">
                  <div class="center-inside-col">
                    <select v-model="selectedYear" class="form-control" :disabled="waitingDownload">
                      <option v-for="year in availableYears" :value="year">{{ year }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <button
                class="btn btn-block btn-success"
                @click="handleDownloadClick"
                :disabled="waitingDownload || selectedParksIds.length === 0"
              >
                Baixar arquivo em formato Excel &nbsp;
                <i class="fa fa-refresh fa-spin" v-if="waitingDownload"></i>
              </button>
            </div>
          </div>
        </section>
      </div>
  </Adminlte>
</template>

<script>
  import Adminlte from '@/components/template/Adminlte'
  import ParksFilter from './ParksFilter'
  import ParkClient from '@/services/resource_client/park'
  import { BackendApi } from '@/services/backend_api'
  import { saveAs } from 'file-saver'

  export default {
    name: 'ExportGeneralInformation',
    components: { Adminlte, ParksFilter },
    data: function () {
      return {
        parks: [],
        selectedYear: null,
        waitingDownload: false,
        parksWithApprovedQuizPerYear: []
      }
    },
    async mounted () {
      this.parksWithApprovedQuizPerYear = await this.getParksWithApprovedParkQuizPerYear()
    },
    methods: {
      async getParksWithApprovedParkQuizPerYear () {
        const response = await ParkClient.withApprovedParkQuizPerYear()
        return response.data
      },
      handleDownloadClick (e) {
        e.preventDefault()

        const queryParams = {
          parks: this.selectedParksIds.join(','),
          year: this.selectedYear
        }

        this.waitingDownload = true
        BackendApi.getClient().get('/spreadsheet/park-quiz', {
          params: queryParams, responseType: 'blob'
        }).then((response) => {
          saveAs(response.data, `park-quiz_${this.selectedYear}.xlsx`)
        }).finally(() => {
          this.waitingDownload = false
        })
      }
    },
    watch: {
      selectedYear (currentSelectedYear, previousSelectedYear) {
        this.parks = []

        if (!currentSelectedYear) {
          return
        }

        const parksWithApprovedQuizInSelectedYear = this.parksWithApprovedQuizPerYear[currentSelectedYear]
        parksWithApprovedQuizInSelectedYear.forEach(park => {
          this.parks.push({...park, 'isSelected': true})
        })
      }
    },
    computed: {
      availableYears: function () {
        return Object.keys(this.parksWithApprovedQuizPerYear)
      },
      selectedParksIds: function () {
        return this.parks.filter((park) => park.isSelected).map((park) => park.id)
      }
    }
  }
</script>

<style scoped>
  .inner-box {
    background-color: #488ab3;
    box-shadow: 0px 1px 5px #888888;
    padding: 10px;
    margin-bottom: 15px;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// ExportParkQuiz.vue?5a39d2d9